// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface V1LogicalRestrictionsSettings
 */
export interface V1LogicalRestrictionsSettings {
  /**
   *
   * @type {boolean}
   * @memberof V1LogicalRestrictionsSettings
   */
  enabled?: boolean;
  /**
   *
   * @type {number}
   * @memberof V1LogicalRestrictionsSettings
   */
  maxNodeCount?: number;
  /**
   *
   * @type {number}
   * @memberof V1LogicalRestrictionsSettings
   */
  maxRelationshipCount?: number;
}

/**
 * Check if a given object implements the V1LogicalRestrictionsSettings interface.
 */
export function instanceOfV1LogicalRestrictionsSettings(
  value: object,
): value is V1LogicalRestrictionsSettings {
  return true;
}

export function V1LogicalRestrictionsSettingsFromJSON(
  json: any,
): V1LogicalRestrictionsSettings {
  return V1LogicalRestrictionsSettingsFromJSONTyped(json, false);
}

export function V1LogicalRestrictionsSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1LogicalRestrictionsSettings {
  if (json == null) {
    return json;
  }
  return {
    enabled: json['enabled'] == null ? undefined : json['enabled'],
    maxNodeCount:
      json['maxNodeCount'] == null ? undefined : json['maxNodeCount'],
    maxRelationshipCount:
      json['maxRelationshipCount'] == null
        ? undefined
        : json['maxRelationshipCount'],
  };
}

export function V1LogicalRestrictionsSettingsToJSON(
  json: any,
): V1LogicalRestrictionsSettings {
  return V1LogicalRestrictionsSettingsToJSONTyped(json, false);
}

export function V1LogicalRestrictionsSettingsToJSONTyped(
  value?: V1LogicalRestrictionsSettings | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    enabled: value['enabled'],
    maxNodeCount: value['maxNodeCount'],
    maxRelationshipCount: value['maxRelationshipCount'],
  };
}
